import React from 'react';
// import { ExtraColumnConfig } from '~/components/DataTable/types';
import Search from '~/components/Search';
import { Container } from './styles';

// Os códigos abaixo são um exemplo de como criar uma coluna extra na tabela com ações customizadas.
// Jamais apague o qualquer código comentado, sem antes consultar o Gilberto.

// const ActionCell: React.FC<{
//   row: any;
//   rowIndex: number;
//   onRowClick?: (p: { row: any }) => void;
// }> = ({ row, onRowClick }) => {
//   return (
//     <button
//       type="button"
//       onClick={(e) => {
//         e.stopPropagation();
//         // onRowClick?.({ row });
//         console.log('Editar', row);
//       }}
//       aria-label={`Editar item ${row?.id ?? ''}`}
//       style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}
//       title="Editar"
//     >
//       ✏️
//     </button>
//   );
// };

// const extraColumn: ExtraColumnConfig = {
//   component: ActionCell,
//   position: 'right', // 'left' ou 'right'
//   sticky: true, // fixar a coluna
//   headerName: 'Ações', // título no cabeçalho
//   width: 80, // px
// };

const RelatorioDiferencaLancamentos: React.FC = () => {
  function defaultOnlyReport() {
    return false;
  }
  return (
    <Container>
      <Search
        codTela={300}
        onlyReport
        newData={defaultOnlyReport}
        onRowClick={defaultOnlyReport}
        // extraColumn={extraColumn}
      />
    </Container>
  );
};

export default RelatorioDiferencaLancamentos;
